module.exports = __webpack_public_path__ + "static/media/defaultCompanyLogo.ecd9c2e8.png";